import styled from '@emotion/styled'
import { FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { theme } from 'styles/theme/hav-theme'

type FieldWrapperProps = {
  templateColumns: string
}

export const UploadCard = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${theme.spacing.lg};
  width: 100%;
  max-width: 600px;
  gap: ${theme.spacing.lg};

  h5 {
    font-weight: ${theme.typography.weight.lg};
    font-size: ${theme.typography.sizes['2md']};
    margin: 0;
    text-align: center;
  }
  background: ${theme.colors.neutral.white};
  border-radius: ${theme.shapes.borderRadius.md};
  box-shadow: 0px 0px 6px rgba(92, 92, 92, 0.102);
`

export const TemplateSpreadsheetContent = styled('div')`
  border: 1px solid ${theme.colors.alert.info.main};
  box-sizing: border-box;
  border-radius: ${theme.spacing.sm};
  padding: ${theme.spacing.xm};
  margin-top: 70px;
  width: 100%;
  max-width: 390px;
  display: flex;
  flex-direction: column;

  h5 {
    color: ${theme.colors.neutral.white};
    background-color: ${theme.colors.alert.success.dark};
    padding: 3px;
    border-radius: 1.93182px;
  }

  p {
    font-size: ${theme.typography.sizes.xs};
    margin-top: ${theme.spacing.lg};
    margin-bottom: ${theme.spacing.lg};
  }
`

export const TemplateSpreadsheetHead = styled('div')`
  display: flex;
  justify-content: space-between;

  h4,
  h5 {
    margin: 0;
  }

  h4 {
    line-height: 23px;
  }
`

export const OrderConfig = styled.div`
  display: grid;
  grid-gap: ${theme.spacing.lg};
`
export const FieldWrapper = styled.div<FieldWrapperProps>`
  display: grid;
  grid-template-columns: ${(props) => props.templateColumns};
  grid-gap: ${theme.spacing.lg};
  width: 100%;

  .fieldItemWrapper {
    display: flex;
    flex-direction: column;
  }

  @media only screen and (max-width: ${theme.breakpoints.lg}px) {
    grid-template-columns: 1fr 1fr;
  }
`

export const ConfigHeader = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing.lg} 0;
`

export const OrderByAvailableDeliveryDatesWrapper = styled.div`
  display: flex;
  align-items: end;
  gap: ${theme.spacing.lg};

  @media only screen and (max-width: ${theme.breakpoints.lg}px) {
    flex-direction: column;
    align-items: inherit;
  }
`

export const OrderByAvailableDeliveryDates = styled.div`
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;

  div {
    width: ${theme.spacing.xm};
    margin: ${theme.spacing.xs} ${theme.spacing.md} 0;
  }

  p {
    margin: ${theme.spacing.md};
  }
`

export const PrioritizeFactories = styled.div`
  display: flex;
  flex-direction: column;

  .label {
    display: flex;
    align-items: center;
  }
`

export const LabelInfos = styled('label')`
  cursor: inherit;
  color: ${theme.colors.neutral.medium};
  font-size: ${theme.typography.sizes.xs};
  font-family: ${theme.typography.family.primary};
  font-weight: ${theme.typography.weight.lg};
`
export const RadioGroupStyled = styled(RadioGroup)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  @media (max-width: ${theme.breakpoints.md}px) {
    justify-content: space-between;
    margin: ${`0 0 ${theme.spacing.xm} 0`};
  }
`

export const FormControlLabelStyled = styled(FormControlLabel)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: -3px;
  margin-right: ${theme.spacing.lg};

  span:nth-of-type(2) {
    margin: calc(0.7 * ${theme.spacing.xs}) 0 0 0;
  }

  @media (max-width: ${theme.breakpoints.md}px) {
    margin: ${`${theme.spacing.xs} 0 0 0`};

    span:nth-of-type(2) {
      margin: 0;
    }
  }

  :last-of-type {
    margin-right: 0px;
  }

  .MuiFormControlLabel-label.Mui-disabled {
    color: ${theme.colors.neutral.lighthover};
  }
`

export const RadioStyled = styled(Radio)`
  padding: 0px;
  margin: 0 ${theme.spacing.xs} calc(0.35 * ${theme.spacing.xs})
    calc(0.35 * ${theme.spacing.xs});
  font-size: ${theme.typography.sizes['2md']};
  @media (max-width: ${theme.breakpoints.md}px) {
    svg {
      width: ${theme.spacing.xm};
      height: ${theme.spacing.xm};
      margin: 0 0 calc(0.5 * ${theme.spacing.xs}) 0;
    }
  }
`
export const SampleHeaderWrapper = styled.div`
  padding: ${theme.spacing.md} ${theme.spacing.xm} 0;
`
